<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getCalculatorBySlug } from '@/calculators/registry'
import CalculatorShell from '@/components/calculator/CalculatorShell.vue'
import NotFoundView from './NotFoundView.vue'

const route = useRoute()
const slug = computed(() => route.params.slug as string)
const calculator = computed(() => getCalculatorBySlug(slug.value))
</script>

<template>
  <CalculatorShell v-if="calculator" :definition="calculator" />
  <NotFoundView v-else />
</template>
